import { useState } from "react";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import Loader from "../../../Common/Loader/Loader";
import TextInput from "../../../Inputs/TextInput/TextInput";
import { sendResetPasswordEmail } from "../../../../helpers/usersHelper";
import FormHeader from "../../FormHeader/FormHeader";
import FormFooter from "../../FormFooter/FormFooter";
import { useToasts } from "react-toast-notifications";
import { useAnalytics } from "../../../../contexts/Segment/Segment";

const ResetPasswordForm = () => {
  const router = useRouter();
  const { register, handleSubmit, formState } = useForm();
  const [isLoading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const analytics = useAnalytics();

  const requestNewPasswordEmail = async ({ email }) => {
    setLoading(true);
    const response = await sendResetPasswordEmail(email);

    setLoading(false);
    if (response) {
      analytics.track("Sent Reset Password Email");
      addToast(
        `We have sent you an email with a link to reset your password.`,
        {
          appearance: "success",
          autoDismiss: false,
        }
      );
      router.push("/login");
    }
  };

  const onError = (data) => {
    console.log("onError", data);
  };

  return (
    <div className="w-full">
      <div className="p-6 sm:p-12">
        <FormHeader
          title="Reset Password"
          description="Enter your email below to reset your password."
        />
        <TextInput
          label="Email"
          register={register}
          type="email"
          name="email"
          disabled={isLoading}
          errors={formState?.errors}
        />
      </div>
      <FormFooter>
        <div className="px-2 sm:px-6 py-2">
          <PrimaryButton
            onClick={() => handleSubmit(requestNewPasswordEmail, onError)()}
            size="md"
            fullWidth
            disabled={isLoading}
          >
            <Loader show={isLoading} />
            {!isLoading && "Send Password Reset Email"}
          </PrimaryButton>
        </div>
      </FormFooter>
    </div>
  );
};

export default ResetPasswordForm;
